"use client";

import { useEffect, useRef } from "react";
import { getOptions } from "@/api";

const LinkedInInsight = () => {
    const initialized = useRef(false);

    useEffect(() => {
        const loadLinkedInInsight = async () => {
            try {
                const options = await getOptions();
                const partnerId = options?.linkedin_insight || "";

                if (!partnerId) return;

                if (typeof window === "undefined") return;

                // Prevent duplicate initialization
                if (initialized.current) return;

                window._linkedin_partner_id = partnerId;

                window._linkedin_data_partner_ids =
                    window._linkedin_data_partner_ids || [];

                window._linkedin_data_partner_ids.push(partnerId);

                // Prevent loading the script more than once
                if (
                    document.querySelector(
                        'script[src="https://snap.licdn.com/li.lms-analytics/insight.min.js"]'
                    )
                ) {
                    initialized.current = true;
                    return;
                }

                // Load LinkedIn Insight Tag
                const script = document.createElement("script");

                script.type = "text/javascript";
                script.async = true;
                script.src =
                    "https://snap.licdn.com/li.lms-analytics/insight.min.js";

                const firstScript =
                    document.getElementsByTagName("script")[0];

                if (firstScript?.parentNode) {
                    firstScript.parentNode.insertBefore(
                        script,
                        firstScript
                    );
                } else {
                    document.head.appendChild(script);
                }

                initialized.current = true;

            } catch (error) {
                console.error(
                    "Failed to load LinkedIn Insight:",
                    error
                );
            }
        };

        loadLinkedInInsight();
    }, []);

    return null;
};

export default LinkedInInsight;